import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-gift-card-picker _mt-4",
  "data-qa": "gift-card-picker"
}
const _hoisted_2 = { class: "gfu-heading gfu-heading--top-divider _mb-0" }
const _hoisted_3 = { class: "gfu-gift-card-picker__description _mt-1 _mb-3" }
const _hoisted_4 = { class: "gfu-gift-card-picker__list" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_redeem_gift_card_item = _resolveComponent("redeem-gift-card-item")

  return ($options.isVisible)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.GiftCardPickerTitle), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.GiftCardPickerDescription), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orderStore.giftCards, (giftCard) => {
            return (_openBlock(), _createBlock(_component_redeem_gift_card_item, {
              key: giftCard.giftCardID,
              "gift-card": giftCard,
              "currency-symbol": $props.currencySymbol,
              "is-temporarily-disabled": $options.isGiftCardTemporarilyDisabled,
              onGiftCardsChanged: _cache[0] || (_cache[0] = $event => (_ctx.$emit('gift-cards-changed')))
            }, null, 8 /* PROPS */, ["gift-card", "currency-symbol", "is-temporarily-disabled"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}